export default __webpack_public_path__ + "static/media/code.28e8a943.wav";